var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top", "label-width": "90px" } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "user-type",
              attrs: { label: "请选择该节点的审批人", prop: "text" },
            },
            [
              _c("div", { staticClass: "radio-sub-name" }, [
                _c("div", { staticClass: "name" }, [_vm._v("常用审批人")]),
                _c("div", { staticClass: "name" }, [_vm._v("主管")]),
              ]),
              _c(
                "el-radio-group",
                {
                  staticClass: "radio-group",
                  on: {
                    change: function ($event) {
                      return _vm.changeAssignedType(_vm.nodeProps.assignedType)
                    },
                  },
                  model: {
                    value: _vm.nodeProps.assignedType,
                    callback: function ($$v) {
                      _vm.$set(_vm.nodeProps, "assignedType", $$v)
                    },
                    expression: "nodeProps.assignedType",
                  },
                },
                _vm._l(_vm.approvalTypes, function (t, index) {
                  return _c(
                    "el-radio",
                    {
                      key: t.type,
                      class: "radio-" + index,
                      attrs: { label: t.type },
                    },
                    [
                      _c("span", { staticClass: "radio-name" }, [
                        _vm._v(_vm._s(t.name)),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _vm.nodeProps.assignedType === "ASSIGN_USER"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select-u",
                          attrs: {
                            "value-key": "name",
                            placeholder: "指定成员",
                            size: "medium",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectUser.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.nodeProps.assignedUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.nodeProps, "assignedUser", $$v)
                            },
                            expression: "nodeProps.assignedUser",
                          },
                        },
                        _vm._l(
                          _vm.nodeProps.assignedUser,
                          function (wc, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: wc.name, value: wc },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "SELF_SELECT"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-person",
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.nodeProps.selfSelect.multiple,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nodeProps.selfSelect,
                                "multiple",
                                $$v
                              )
                            },
                            expression: "nodeProps.selfSelect.multiple",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: false } }, [
                            _vm._v("自选一个人"),
                          ]),
                          _c("el-radio-button", { attrs: { label: true } }, [
                            _vm._v("自选多个人"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "LEADER_TOP"
                ? _c(
                    "div",
                    [
                      _c("el-divider"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "approve-end",
                          attrs: { label: "审批终点", prop: "text" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.nodeProps.leaderTop.endCondition,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nodeProps.leaderTop,
                                    "endCondition",
                                    $$v
                                  )
                                },
                                expression: "nodeProps.leaderTop.endCondition",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "TOP" } }, [
                                _vm._v("直到最上层主管"),
                              ]),
                              _c("el-radio", { attrs: { label: "LEAVE" } }, [
                                _vm._v("不超过发起人的"),
                              ]),
                            ],
                            1
                          ),
                          _vm.nodeProps.leaderTop.endCondition === "LEAVE"
                            ? _c(
                                "div",
                                { staticClass: "approve-end-leave" },
                                [
                                  _c("span", [_vm._v("第 ")]),
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      max: 20,
                                      step: 1,
                                      size: "mini",
                                    },
                                    model: {
                                      value: _vm.nodeProps.leaderTop.level,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.nodeProps.leaderTop,
                                          "level",
                                          $$v
                                        )
                                      },
                                      expression: "nodeProps.leaderTop.level",
                                    },
                                  }),
                                  _c("span", [_vm._v(" 级主管")]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "LEADER"
                ? _c("div", [
                    _c("span", { staticClass: "item-desc" }, [
                      _vm._v("发起人直接上级将作为审批人处理审批单"),
                    ]),
                  ])
                : _vm.nodeProps.assignedType === "DEPT_LEADER"
                ? _c("div", [
                    _c(
                      "span",
                      { staticClass: "item-desc" },
                      [
                        _vm._v("发起人的 "),
                        _c(
                          "el-select",
                          {
                            staticClass: "select-level",
                            attrs: { size: "small" },
                            model: {
                              value: _vm.nodeProps.leader.level,
                              callback: function ($$v) {
                                _vm.$set(_vm.nodeProps.leader, "level", $$v)
                              },
                              expression: "nodeProps.leader.level",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "第2级主管", value: 2 },
                            }),
                            _c("el-option", {
                              attrs: { label: "第3级主管", value: 3 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm.nodeProps.assignedType === "ROLE"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select-u",
                          attrs: {
                            "value-key": "name",
                            placeholder: "指定角色",
                            size: "medium",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectRole.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.nodeProps.role,
                            callback: function ($$v) {
                              _vm.$set(_vm.nodeProps, "role", $$v)
                            },
                            expression: "nodeProps.role",
                          },
                        },
                        _vm._l(_vm.nodeProps.role, function (wc, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: wc.name, value: wc },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "FORM_USER"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "approve-end",
                          attrs: { label: "选择表单联系人项", prop: "text" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "80%" },
                              attrs: {
                                size: "small",
                                placeholder: "请选择包含联系人的表单项",
                              },
                              model: {
                                value: _vm.nodeProps.formUser,
                                callback: function ($$v) {
                                  _vm.$set(_vm.nodeProps, "formUser", $$v)
                                },
                                expression: "nodeProps.formUser",
                              },
                            },
                            _vm._l(_vm.forms, function (op) {
                              return _c("el-option", {
                                key: op.id,
                                attrs: { label: op.title, value: op.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _c("span", { staticClass: "item-desc" }, [
                      _vm._v("发起人自己将作为审批人处理审批单"),
                    ]),
                  ]),
            ],
            1
          ),
          _c("el-divider"),
          !(_vm.nodeProps.assignedType == "SELF")
            ? _c(
                "el-form-item",
                {
                  staticClass: "line-mode",
                  attrs: { label: "审批人为空时", prop: "text" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.nodeProps.nobody.handler,
                        callback: function ($$v) {
                          _vm.$set(_vm.nodeProps.nobody, "handler", $$v)
                        },
                        expression: "nodeProps.nobody.handler",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "TO_PASS" } }, [
                        _c("span", { staticClass: "radio-name" }, [
                          _vm._v("自动通过"),
                        ]),
                      ]),
                      _c("el-radio", { attrs: { label: "TO_REFUSE" } }, [
                        _c("span", { staticClass: "radio-name" }, [
                          _vm._v("自动拒绝"),
                        ]),
                      ]),
                      _c("el-radio", { attrs: { label: "TO_ADMIN" } }, [
                        _c("span", { staticClass: "radio-name" }, [
                          _vm._v("自动转交管理员"),
                        ]),
                      ]),
                      _c("el-radio", { attrs: { label: "TO_USER" } }, [
                        _c("span", { staticClass: "radio-name" }, [
                          _vm._v("指定成员审批"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm.nodeProps.nobody.handler === "TO_USER"
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "select-u",
                              attrs: {
                                "value-key": "name",
                                placeholder: "指定成员审批",
                                size: "medium",
                                multiple: "",
                                "popper-class": "hidden",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.selectNoSetUser.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.nodeProps.nobody.assignedUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nodeProps.nobody,
                                    "assignedUser",
                                    $$v
                                  )
                                },
                                expression: "nodeProps.nobody.assignedUser",
                              },
                            },
                            _vm._l(
                              _vm.nodeProps.nobody.assignedUser,
                              function (wc, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: wc.name, value: wc },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.showMode
            ? _c(
                "div",
                [
                  _c("el-divider"),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "approve-mode",
                      attrs: {
                        label: "多人审批时采用的审批方式",
                        prop: "text",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.nodeProps.mode,
                            callback: function ($$v) {
                              _vm.$set(_vm.nodeProps, "mode", $$v)
                            },
                            expression: "nodeProps.mode",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "AND" } }, [
                            _c("span", { staticClass: "radio-name" }, [
                              _vm._v("会签（需要所有审批人都同意才可通过）"),
                            ]),
                          ]),
                          _c("el-radio", { attrs: { label: "OR" } }, [
                            _c("span", { staticClass: "radio-name" }, [
                              _vm._v("或签（其中一名审批人同意或拒绝即可）"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickerTitle, multiple: _vm.multiple },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }